import { TeamMemberSchema } from "shared/types/__generated__/validation"

import z from "zod"

import { TeamFragment } from "../graphql/fragment.generated"

export type Team = TeamFragment

export const TeamsAPIType = "teams" as const
export const TeamTypename = "Team" as const

export const TeamSchema = z.object({
  __typename: z
    .literal(TeamTypename)
    .nullish()
    .transform(() => TeamTypename),
  createdAt: z.string(),
  updatedAt: z.string(),
  id: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  memberships: z.array(z.lazy(() => TeamMemberSchema()))
})
